// Stub commands for BankApp (disabled in DocsApp mode)
export const commands: any[] = [];
